import { useEffect } from 'react';

type Props = { title: string };

export function DocumentTitle({ title }: Props): null {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return null;
}
